import { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import Dialog, { DialogTitle, DialogContent, DialogContentText, DialogActions } from 'beam/dist/Dialog'
import Button from 'beam/dist/Button'

class IdleDialog extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    timeout: PropTypes.number,
    onConfirm: PropTypes.func.isRequired,
    onTimeout: PropTypes.func.isRequired,
  }

  static defaultProps = {
    timeout: 15000, // 15 seconds
  }

  timeoutRef = null

  componentDidUpdate(prevProps) {
    const { open, timeout, onTimeout } = this.props

    if (prevProps.open !== open) {
      if (this.timeoutRef) {
        clearTimeout(this.timeoutRef)
      }

      if (open) {
        this.timeoutRef = setTimeout(() => {
          onTimeout()
        }, timeout)
      }
    }
  }

  componentWillUnmount() {
    if (this.timeoutRef) {
      clearTimeout(this.timeoutRef)
    }
  }

  render() {
    const { open, onConfirm, t } = this.props

    return (
      <Dialog open={open}>
        <DialogTitle>{t('sessionTimout')}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t('sessionTimeoutMessage')}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onConfirm} color="primary">
            {t('keepMeLoggedIn')}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withTranslation()(IdleDialog)
